import { render } from "./OutsorsingBanner.vue?vue&type=template&id=9144cc1c"
const script = {}

import "./OutsorsingBanner.vue?vue&type=style&index=0&id=9144cc1c&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__